import * as React from 'react';
import { SVGProps } from 'react';

const IconSnowflakeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 8 3.782 9.28.567 8.42l-.259.966 2.25.603-1.986 1.146 1 1.732 1.986-1.146-.603 2.249.966.258.861-3.215L7 9.732v2.56l-2.354 2.354.708.707L7 13.707V16h2v-2.293l1.646 1.646.708-.707L9 12.293v-2.56l2.218 1.28.861 3.214.966-.258-.602-2.25 1.985 1.147 1-1.732-1.986-1.146 2.25-.603-.26-.966-3.214.861L10 8l2.218-1.28 3.215.861.259-.966-2.25-.603 1.986-1.146-1-1.732-1.986 1.146.603-2.249-.966-.259-.861 3.216L9 6.268v-2.56l2.354-2.354-.707-.708L9 2.293V0H7v2.293L5.354.646l-.708.708L7 3.707v2.561l-2.218-1.28-.861-3.216-.966.26.603 2.248-1.986-1.146-1 1.732 1.986 1.146-2.25.603.26.966 3.214-.861L6 8Z" />
  </svg>
);
export default IconSnowflakeSizeS;
